import { render, staticRenderFns } from "./ed-deck-card-change-name-modal.component.vue?vue&type=template&id=3da3b850&scoped=true&"
import script from "./ed-deck-card-change-name-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-card-change-name-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-card-change-name-modal.component.scss?vue&type=style&index=0&id=3da3b850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da3b850",
  null
  
)

export default component.exports